module.exports = __webpack_public_path__ + "img/ISFJ.9f382ccc.png";